import React from "react";

const NotFound = () => (
    <div>The page you're looking for could not be found</div>
);

export default NotFound;
